import PropTypes from "prop-types";
import { Icon as PolarisIcon } from "@shopify/polaris";
import styled from "styled-components";

// Polaris color palettes for statuses
const COLOR_MAP = {
  default: {
    lighter: "#f4f6f8",
    lightest: "#fafbfc",
    main: "#dfe3e8",
    contrast: "#202223",
    border: "#c4cdd5",
  },
  primary: {
    lighter: "#d6e4ff",
    lightest: "#ebf5ff",
    main: "#006fbb",
    contrast: "#ffffff",
    border: "#084c8a",
  },
  success: {
    lighter: "#c8f5e3",
    lightest: "#f6fcf8",
    main: "#008060",
    contrast: "#ffffff",
    border: "#054732",
  },
  warning: {
    lighter: "#ffe7d6",
    lightest: "#fff8ed",
    main: "#c66900",
    contrast: "#ffffff",
    border: "#914c00",
  },
  error: {
    lighter: "#fbeae5",
    lightest: "#fdf7f6",
    main: "#d82c0d",
    contrast: "#ffffff",
    border: "#a21a02",
  },
  info: {
    lighter: "#d9f0ff",
    lightest: "#f4faff",
    main: "#0c63e4",
    contrast: "#ffffff",
    border: "#0846a1",
  },
};

const getColorStyles = (color, variant) => {
  const palette = COLOR_MAP[color] || COLOR_MAP.default;

  switch (variant) {
    case "filled":
      return `
        color: ${palette.contrast};
        background-color: ${palette.main};
      `;
    case "outlined":
      return `
        color: ${palette.main};
        background-color: transparent;
        border: 1px solid ${palette.border};
      `;
    case "ghost":
      return `
        color: ${palette.main};
        background-color: ${palette.lighter};
      `;
    default:
      return `
        color: ${palette.main};
        background-color: ${palette.lightest};
      `;
  }
};

// ----------------------------------------------------------------------

const RootStyle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  min-width: 22px;
  line-height: 1;
  border-radius: 6px;
  padding: 0 8px;
  font-size: 12px;
  font-weight: bold;
  cursor: default;
  text-transform: capitalize;
  ${({ color, variant }) => getColorStyles(color, variant)}
`;

// ----------------------------------------------------------------------

Label.propTypes = {
  children: PropTypes.node,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  color: PropTypes.oneOf(["default", "primary", "success", "warning", "error", "info"]),
  variant: PropTypes.oneOf(["filled", "outlined", "ghost"]),
  style: PropTypes.object,
};

export default function Label({ children, color = "default", variant = "ghost", startIcon, endIcon, style }) {
  const iconStyle = {
    width: 16,
    height: 16,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg, img": { width: "100%", height: "100%", objectFit: "cover" },
  };

  return (
    <RootStyle color={color} variant={variant} style={style}>
      {startIcon && <span style={{ marginRight: "8px", ...iconStyle }}>{<PolarisIcon source={startIcon} />}</span>}

      {children}

      {endIcon && <span style={{ marginLeft: "8px", ...iconStyle }}>{<PolarisIcon source={endIcon} />}</span>}
    </RootStyle>
  );
}
